<template> 
  <v-layout 
    column 
    v-scroll="onScroll" 
    fill-height>  
      <!-- NAVIGATION DRAWER -->
      <not-navbar   :not="not" :navOpen="navOpen"/>  
      <not-toolbar v-if="ACCESS_PAGES"  :not="not" @navOpen="navOpen=!navOpen"/> 
      
      <!-- MAIN BODY        -->
      <v-main class="b1"> 
        <v-divider></v-divider> 
        <mbs-access-page @navOpen="navOpen=!navOpen" :not="not" v-model="ACCESS_PAGES"/>
        <v-layout v-if="ACCESS_PAGES" column  fill-height class=" ma-0 pa-0">
          <router-view :not="not"/>  
          <v-spacer></v-spacer>  
          <not-footer v-if="ACCESS_PAGES" :not="not"/>  
        </v-layout> 
         
      </v-main> 
      <mbs-dialog/> 
      <mbs-dialog-input/> 
      <mbs-dialog-progress/> 
      <mbs-snackbar/>  
       
      <not-dialog
        @notNo="onNotNoDialog()" 
        @notYes="onNotYesDialog()"/> 
      <not-dialog-cp/> 
      <not-dialog-p/> 

  </v-layout> 
</template>

<script>
    import DATA from '../../plugins/DATA'
    import DB from '../../plugins/DB'
    import {mapState} from "vuex" 
    let pageName = 'MainActivity' 
    export default{ 

        name: pageName, 
        data () {
          return { 
            navOpen:false,
            scrolled:null,
            oneClick:false,
            imgLazy:require(`@/assets/system/no-image.png`), 
            ACCESS_PAGES:false,
          } 
        }, 
        mounted(){  
        }, 
        created(){
             this.EventBus.$on('notYesDialog', this.notYesDialog); 
             this.INITIATE_DB(this.us?this.us.uid:null)
             this.USER_MONITOR(100)
        },
        computed: {
          vs(){
            return this.$vuetify.breakpoint
          }, 
          vsn(){
            return this.vs.name
          },
          appName(){
            return this.$store.getters.getAppName
          }, 
          us(){
            let returnUser = this.$store.getters.getUser
            return returnUser
          }, 
          uds(){
            let returnUsers = this.$store.getters.getUsers
            console.log(returnUsers);
            return returnUsers
          }, 
          ud(){
            let returnUser = this.$store.getters.getUserDetails
            console.log(returnUser,'returnUser....');
            return returnUser
          },
          JOINED_ud(){
              let ud = this.ud
              let JOIN_UD = this.JOIN_UD(ud)
              return JOIN_UD
          },
          usr(){
            let returnUsers = this.$store.getters.getUserRoles
            return returnUsers
          },
          loading(){ 
            const loading = this.$store.getters.getLoading
            return loading
          },
          processes(){ 
            const process = this.$store.getters.getProcesses
            return process
          }, 
          responses(){ 
            const re = this.$store.getters.getResponses
            return re
          }, 
          not(){
            return {
              imgLazy:this.imgLazy,
              noImg:this.imgLazy,
              vs:this.vs,
              vsn:this.vsn,
              appName:this.appName,
              pagination:this.pagination,  
              nul:this.nul,
              go:this.go,
              logout:this.logout, 
              restartResponses:this.restartResponses,
              dynamicSort:this.dynamicSort,
              size:this.size,
              permission_delete_user:this.permission_delete_user,
              selectorNames:this.selectorNames,
              selectorCodeName:this.selectorCodeName,
              selectorNamesCode:this.selectorNamesCode,
              findCodeName:this.findCodeName,

              PHONE_NUMBER:this.PHONE_NUMBER,
              TIME_TS:this.TIME_TS,
              //CONVERT
              convertDate:this.convertDate,
              convertTime:this.convertTime,
              CONVERT_STRING_TO_INT:this.CONVERT_STRING_TO_INT,
              CONVERT_STRING_TO_DATE_STRING:this.CONVERT_STRING_TO_DATE_STRING,

              //TEXT
              TEXT_UP:this.TEXT_UP,
              TEXT_UP1:this.TEXT_UP1,
              TEXT_UP11:this.TEXT_UP11,
              TEXT_UP0:this.TEXT_UP0,
              TEXT_EQ:this.TEXT_EQ,
              NUMBER_SHOW:this.NUMBER_SHOW,

              //TABLE HEADER 
              TABLE_HEADERS : this.TABLE_HEADERS,
              TABLE_HEADER_SHOW : this.TABLE_HEADER_SHOW,
              TABLE_HEADER_SELECTOR : this.TABLE_HEADER_SELECTOR,

              //CODE
              CODE_IS_OK:this.CODE_IS_OK,
              CODE_IS_AUTO:this.CODE_IS_AUTO,
              CODE_AUTO_GENERATE:this.CODE_AUTO_GENERATE,
              CODE_GET_FIRST:this.CODE_GET_FIRST,
              CODE_GET_LAST:this.CODE_GET_LAST,
              CODE_CHECK:this.CODE_CHECK,

              //GENDER
              GENDER_NAME:this.GENDER_NAME,
              GENDER_VALUE:this.GENDER_VALUE,

              //JOIN
              JOIN_OBSERVERS:this.JOIN_OBSERVERS,
              JOIN_PARTIES:this.JOIN_PARTIES,
              JOIN_CANDIDATES:this.JOIN_CANDIDATES,
              JOIN_REGIONS:this.JOIN_REGIONS,
              JOIN_DISTRICTS:this.JOIN_DISTRICTS,
              JOIN_CONSTITUENCIES:this.JOIN_CONSTITUENCIES,
              JOIN_WARDS:this.JOIN_WARDS,
              JOIN_CENTRES:this.JOIN_CENTRES,
              JOIN_RESULTS:this.JOIN_RESULTS,
              JOIN_XL_RESULTS:this.JOIN_XL_RESULTS,
              JOIN_LOCATION:this.JOIN_LOCATION,
              JOIN_QUESTIONS:this.JOIN_QUESTIONS,
              JOIN_USER_GROUP:this.JOIN_USER_GROUP,
              JOIN_UDS:this.JOIN_UDS,
              JOIN_UD:this.JOIN_UD,
              JOIN_OBSERVER_LOCATION:this.JOIN_OBSERVER_LOCATION,
              JOIN_USER_LOCATION:this.JOIN_USER_LOCATION,
              JOIN_SMS:this.JOIN_SMS,

              //GROUP
              GROUP_RESULTS:this.GROUP_RESULTS,

              //CALCULATE
              CALCULATE_PLUS:this.CALCULATE_PLUS,
              CALCULATE_CANDIDATES_RESULTS:this.CALCULATE_CANDIDATES_RESULTS,
              CALCULATE_CANDIDATES_RESULTS_BY_LOCATION:this.CALCULATE_CANDIDATES_RESULTS_BY_LOCATION,
              CALCULATE_REGIONS_RESULTS:this.CALCULATE_REGIONS_RESULTS,
              CALCULATE_DISTRICTS_RESULTS:this.CALCULATE_DISTRICTS_RESULTS,
              CALCULATE_DISTRICTS_CANDIDATE_RESULTS:this.CALCULATE_DISTRICTS_CANDIDATE_RESULTS,
              CALCULATE_RESULTS_INDICATOR:this.CALCULATE_RESULTS_INDICATOR,
              CALCULATE_QUESTION_RESPONSE:this.CALCULATE_QUESTION_RESPONSE,
              CALCULATE_QUESTION_RESPONSE1:this.CALCULATE_QUESTION_RESPONSE1,
              CALCULATE_LOCATION_CANDIDATE_RESULTS:this.CALCULATE_LOCATION_CANDIDATE_RESULTS,

              CALCULATE_GEO:this.CALCULATE_GEO,

              //ACCESS & PERMISSIONS
              ACCESS_READ : this.ACCESS_READ,
              ACCESS_WRITE : this.ACCESS_WRITE,
              ACCESS_EDIT : this.ACCESS_EDIT,
              ACCESS_DELETE : this.ACCESS_DELETE,
              ACCESS_PAGE : this.ACCESS_PAGE,
              ACCESS_PERMISSION : this.ACCESS_PERMISSION,

              us:this.us,
              usr:this.usr,
              uds:this.uds,
              ud:this.ud,
              loadedPages:this.loadedPages,
              loading:this.loading,
              processes:this.processes,
              responses:this.responses,
              notDialog:this.notDialog,
              notDialogCp:this.notDialogCp,
              notDialogP:this.notDialogP, 
            }
          },

          //more
          regions(){
              return this.$store.getters.getRegions
          }, 
          districts(){
              return this.$store.getters.getDistricts
          }, 
          constituencies(){
              return this.$store.getters.getConstituencies
          }, 
          wards(){
              return this.$store.getters.getWards
          }, 
          centres(){
              return this.$store.getters.getCentres
          }, 
          candidates(){
              return this.$store.getters.getCandidates 
          }, 
          results(){
            return resultsType=>{
              return this.$store.getters.getResults(resultsType) 
            }
          }, 
          resultsDetails(){
            return resultsType=>{
              return this.$store.getters.getResultsDetails(resultsType)
            }
          },

          questionChecklists(){
              return this.$store.getters.getQuestionChecklists
          },
          questionStages(){
              return this.$store.getters.getQuestionStages
          },
          questionTimelines(){
              return this.$store.getters.getQuestionTimelines
          },
          questionTypes(){
              return this.$store.getters.getQuestionTypes
          },
          questionCategories(){
              return this.$store.getters.getQuestionCategories
          },
          questionResponses(){
              return this.$store.getters.getQuestionResponses
          },
          sms(){
              return this.$store.getters.getSMS
          },
          observers(){
            return this.$store.getters.getObservers
          },
          observerByNumber(){
            let observers = this.observers
            return num=>{
              return observers.find(ob=>{
                return this.PHONE_NUMBER(ob.phone_number) == this.PHONE_NUMBER(num)
              })
            }
          }
          

        }, 
        //---------------methods-----------------//
        methods: { 
            async INITIATE_DB(uid){
              try { 
                if (uid) {
                  await this.$store.dispatch('initialize_uid_items_ref',{uid:uid}) 
                } 
                this.$store.dispatch('fi_tracker',{ 
                  names:[
                    
                    {data_save:false,on:true,get:true,cash:true,name:DATA.ITEMS.COUNTRIES.values},
                    {data_save:false,on:true,get:true,cash:true,name:DATA.ITEMS.REGIONS.values},
                    {data_save:false,on:true,get:true,cash:true,name:DATA.ITEMS.DISTRICTS.values},
                    {data_save:false,on:true,get:true,cash:true,name:DATA.ITEMS.CONSTITUENCIES.values},
                    {data_save:false,on:true,get:true,cash:true,name:DATA.ITEMS.WARDS.values},
                    {data_save:false,on:true,get:true,cash:true,name:DATA.ITEMS.CENTRES.values},
                    {data_save:false,on:true,get:true,cash:true,name:DATA.ITEMS.TRADITION_AUTHORITIES.values},
                    {data_save:false,on:true,get:true,cash:true,name:DATA.ITEMS.REPORTS.values},
                    {data_save:false,on:true,get:true,cash:true,name:DATA.ITEMS.REPORTERS.values},
                    {data_save:false,on:true,get:true,cash:true,name:DATA.ITEMS.REPORTER_CATEGORIES.values},
                    {data_save:false,on:true,get:true,cash:true,name:DATA.ITEMS.QUESTIONNAIRES.values},

                    {data_save:false,on:true,get:true,cash:true,name:DATA.ITEMS.QUESTION_CATEGORIES.values}, 
                    {data_save:false,on:true,get:true,cash:true,name:DATA.ITEMS.QUESTION_TYPES.values}, 
                    {data_save:false,on:true,get:true,cash:true,name:DATA.ITEMS.QUESTION_TIMELINES.values}, 
                    {data_save:false,on:true,get:true,cash:true,name:DATA.ITEMS.QUESTION_STAGES.values}, 
                    
                    {data_save:false,on:true,get:true,cash:true,name:DATA.ITEMS.WHATSAPP_REPORTS.values}, 
                    {data_save:false,on:true,get:true,cash:true,name:DATA.ITEMS.WEB_REPORTS.values}, 
                    {data_save:false,on:true,get:true,cash:true,name:DATA.ITEMS.MOBILE_REPORTS.values}, 
                    {data_save:false,on:true,get:true,cash:true,name:DATA.ITEMS.SMS_REPORTS.values},  
                    {data_save:false,on:true,get:true,cash:true,name:DATA.ITEMS.PERSONAL_REPORTS.values},  
                    {data_save:false,on:true,get:true,cash:true,name:DATA.ITEMS.OCCURRENCES.values},
                  ]
                }).then(res=>{ 
                  console.log(res,'res..---....');
                }).catch(error=>{
                  console.log(error,"error...--...");
                })  
              } catch (error) {
                  this.MBS.actions.error({
                      error:error,
                      from:'INITIATE_DB',
                      page:PAGE_NAME, 
                  })
              }  
            },
            notYesDialog(action){
              if (action) {
                  if (action.code ===pageName+'=REDIRECT-HOME') {
                    if (this.oneClick) {
                      this.go("/") 
                      this.oneClick = false
                    }
                  }  
                  if (action.code ===pageName+'=REDIRECT-LOGIN') {
                    if (this.oneClick) {
                      this.go("/login") 
                      this.oneClick = false
                    }
                  } 
                  if (action.code ===pageName+'=LOGOUT') {
                    this.$store.dispatch("fi_signUserOut")
                  } 
                    
              }
            },
            onScroll (e) { 
              this.scrolled = window.pageYOffset || document.documentElement.scrollTop  
            },
            pagination(list,page,size){ 
              if (!size) {
                return {}
              }
                if (size.toUpperCase==="All".toUpperCase) {
                  size = list.length
                }
                let total = list.length
                let pages = total/size
                let faction = page/pages
                let last = faction*total
                let start = last-size
                //console.log("t:"+total+" f:"+faction+" p:"+pages+" p:"+page+" l:"+last+" s:"+start); 
                return {
                    list:list.slice(start,last),
                    total:total,
                    pages:Math.ceil(pages),
                    start:Math.round(start+1),
                    last:Math.round(total>last?last:total),
                    size:size,
                    page:page,
                    next:page<pages?true:false,
                    prev:page>1?true:false,
                }
            }, 

            //not dialog show
            notDialog(notShow,notHd,notH,notTx,notNoTx,notYesTx,notAction){
                this.$store.dispatch('setNotDialog',{
                    notShow : notShow,
                    notHd : notHd,
                    notH : notH,
                    notTx : notTx,
                    notNoTx : notNoTx,
                    notYesTx : notYesTx,
                    notAction:notAction
                }) 
            },
            notDialogCp(notShow,notHd,notH,notTx,notNoTx,notYesTx,notAction){
                this.$store.dispatch('setNotDialogCp',{
                    notShow : notShow,
                    notHd : notHd,
                    notH : notH,
                    notTx : notTx,
                    notNoTx : notNoTx,
                    notYesTx : notYesTx,
                    notAction:notAction
                })  
            },
            notDialogP(notShow,notHd,notTx,notCl){
                this.$store.dispatch('setNotDialogP',{
                    notShow : notShow,
                    notHd : notHd,
                    notTx : notTx,
                    notCl : notCl
                })  
            },
            dynamicSort(property,asc){
              var sortOrder = 1;
              if(property[0] === "-") {
                  sortOrder = -1;
                  property = property.substr(1);
              }
              return function (a,b) {
                  /* next line works with strings and numbers, 
                  * and you may want to customize it to your needs
                  */
                  var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
                  if (asc) {
                    return result * sortOrder;
                  }else{
                    return -1 * (result * sortOrder);
                  } 
              }
            },
            nul(value){ 
              if (!value) {
                return true
              } 
              if (value===0) {
                return true
              } 

              function isEmpty(obj) {
                for(var prop in obj) {
                  if(obj.hasOwnProperty(prop)) {
                    return false;
                  }
                }

                return JSON.stringify(obj) === JSON.stringify({});
              } 
              return isEmpty(value)
            },
            go(to){
              this.$router.push(to)
            },
            logout(){
              this.notDialog(true,true,"Logout","Are you sure you want to logout?","CANCEL","LOGOUT",{
                code:pageName+"=LOGOUT"
              })
              
            }, 
            restartResponses(){
              this.$store.dispatch("restartResponses")
            },
            size(arr){
              return arr?arr.length:0
            },


            //TIME
            TIME_SHOW(time,format){
              if (this.TEXT_UP(format)==="YYYY-MM-DD HH:MM:SS") {
                
              }
            },
            TIME_TS(ts,format){
              if(!ts){return null}
              let ts_ms = ts * 1000;
              // initialize new Date object
              let date_ob = new Date(ts_ms);
              // year as 4 digits (YYYY)
              let year = date_ob.getFullYear(); 
              // month as 2 digits (MM)
              let month = ("0" + (date_ob.getMonth() + 1)).slice(-2); 
              // date as 2 digits (DD)
              let date = ("0" + date_ob.getDate()).slice(-2); 
              // hours as 2 digits (hh)
              let hours = ("0" + date_ob.getHours()).slice(-2); 
              // minutes as 2 digits (mm)
              let minutes = ("0" + date_ob.getMinutes()).slice(-2); 
              // seconds as 2 digits (ss)
              let seconds = ("0" + date_ob.getSeconds()).slice(-2);

              return date + "/" + month + "/" + year + " " + hours + ":" + minutes 
            },
            PHONE_NUMBER(num){
              if(!num){return null}
              let no = num+''
              let size = no.length
              if (size===9) {
                return "+265"+no
              }else if (size===10) {
                return "+265"+no.slice(1)
              }else{
                return no
              }
            },

            //CONVERT
            convertDate(s_date,numbers){ 
              if (!s_date) {
                return "00/00/0000"
              } 
              const monthNames = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
              ];
              const montShortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
              ];
              var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
              var dayShortNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
              
              let date =  new Date(s_date);
              if (numbers) {
                date = new Date(0,0,s_date)
              }
              let newDate = ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' +((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' +  date.getFullYear()

              let newTime=(date.getHours())+":"+(date.getMinutes())
              return newDate+" "+newTime
            },
            convertTime(time){ 
              if (!time) {
                return "00:00"
              }  
              let date =  new Date(time); 
              let newTime=(date.getHours())+":"+(date.getMinutes())
              return  newTime
            },
            CONVERT_STRING_TO_DATE_STRING(s_date,){ 
              if (!s_date) {
                return "2020-01-01"
              }  
              let date =  new Date(s_date);  
              let newDate = 
                  (date.getFullYear())
                  + '-' +
                  ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1)))
                  + '-' +
                  ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate()))
                if (newDate.includes("NaN")) {
                  return "2020-01-01"
                }
              return newDate 
            },
            CONVERT_STRING_TO_INT(string){
              if (!string) {return 0}
              string = string.replace ( /[^\d.]/g, '' );
              return parseInt(string, 10)
            },

            TEXT_UP(text){
              if (!text) {return null}
              let tx = text.toUpperCase()
              return tx
            },
            TEXT_UP1(text){
              if (!text) {return null}
              let tx = text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
              return tx
            },
            TEXT_UP11(text){
              if (!text) {return null}
              var splitStr = text.toLowerCase().split(' ');
              for (var i = 0; i < splitStr.length; i++) { 
                  splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
              } 
              return splitStr.join(' '); 
            },
            TEXT_UP0(text){
              if (!text) {return null} 
              return text.toLowerCase(); 
            },
            TEXT_EQ(text,text2){
              if (this.TEXT_UP(text)===this.TEXT_UP(text2)) {
                return true
              } 
              return false 
            },
            NUMBER_SHOW(number){
              number =  number?number*1:0
              return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },

            //TABLE HEADERS
            TABLE_HEADERS(customeHeader){ 
              let headers = []
                //general
                if (this.TABLE_HEADER_SHOW(customeHeader,'Image')) {
                    headers.push({ text: '',align: 'left', value: 'image',sortable: false})
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,'Number')) {
                    headers.push({ text: 'NO.',align: 'left', value: 'no',sortable: true})
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,'Level')) {
                    headers.push({ text: 'LEVEL',align: 'left', value: 'level',sortable: true})
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,'Name')) {
                    headers.push({ text: 'NAME',align: 'left', value: 'name',sortable: true})
                }

                //question
                if (this.TABLE_HEADER_SHOW(customeHeader,'Question Number')) {
                    headers.push({ text: 'Q_NO.',value: 'question_number',sortable: true},)
                } 
                if (this.TABLE_HEADER_SHOW(customeHeader,'Question')) {
                    headers.push({ text: 'QUESTION',align: 'justify', value: 'question_body',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,'Question Tag')) {
                    headers.push({ text: 'Q_TAG',value: 'question_tag',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,'Question Tag Value')) {
                    headers.push({ text: 'Q_TAG_VALUE',value: 'question_tag_value',sortable: true},)
                } 
                if (this.TABLE_HEADER_SHOW(customeHeader,'Question Category')) {
                    headers.push({ text: 'Q_CATEGORY',value: 'question_category_name',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,'Question Category Code')) {
                    headers.push({ text: 'Q_CATEGORY',value: 'question_category_code',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,'Question Type')) {
                    headers.push({ text: 'Q_TYPE',value: 'question_type_name',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,'Question Type Code')) {
                    headers.push({ text: 'Q_TYPE',value: 'question_type_code',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,'Question Stage')) {
                    headers.push({ text: 'Q_STAGE',value: 'question_stage_name',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,'Question Stage Code')) {
                    headers.push({ text: 'Q_STAGE',value: 'question_stage_code',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,'Question Timeline')) {
                    headers.push({ text: 'Q_TIMELINE',value: 'question_timeline_name',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,'Question Timeline Code')) {
                    headers.push({ text: 'Q_TIMELINE',value: 'question_timeline_code',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,'Question Has Explanation')) {
                    headers.push({ text: 'Q_HAS_EXPL',value: 'question_explanation',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,'Question Predefined Answers')) {
                    headers.push({ text: 'Q_PRE_ANSWER',value: 'question_predefined_answer',sortable: true},)
                } 
                if (this.TABLE_HEADER_SHOW(customeHeader,'Question Flagged')) {
                    headers.push({ text: 'FLAGGED',value: 'question_flagged',sortable: true},)
                }

                //Response
                if (this.TABLE_HEADER_SHOW(customeHeader,'Question Answer')) {
                    headers.push({ text: 'Q_ANSWER',value: 'question_answer',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,'Answer')) {
                    headers.push({ text: 'ANSWER',value: 'answer',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,'Explanation')) {
                    headers.push({ text: 'EXPLANATION',value: 'explanation',sortable: true},)
                }

                //Abserver 
                if (this.TABLE_HEADER_SHOW(customeHeader,"First Name")) {
                    headers.push({ text: 'FIRST NAME',  value: 'first_name',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"Last Name")) {
                    headers.push({ text: 'LAST NAME',  value: 'last_name',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"Email")) {
                    headers.push({ text: 'EMAIL',  value: 'email',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"Phone Number")) {
                    headers.push({ text: 'PHONE',  value: 'phone_number',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"Password")) {
                    headers.push({ text: 'PASSWORD',  value: 'password',sortable: true},)
                }
                
              
                //candidate
                if (this.TABLE_HEADER_SHOW(customeHeader,'Candidate Name')) {
                    headers.push({ text: 'CANDIDATE',value: 'candidate_name',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,'Candidate Code')) {
                    headers.push({ text: 'CANDIDATE CODE', value: 'candidate_code',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,'Candidate Gender')) {
                    headers.push({ text: 'CANDIDATE GENDER',value:'candidate_gender',sortable: true})
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,'Gender')) {
                    headers.push({ text: 'GENDER',value:'gender',sortable: true})
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,'Candidate Age')) {
                    headers.push({ text: 'CANDIDATE AGE', value: 'candidateAge',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,'Age')) {
                    headers.push({ text: 'AGE', value: 'age',sortable: true},)
                }

                
                 

                if (this.TABLE_HEADER_SHOW(customeHeader,"Observer Name")) {
                    headers.push({ text: 'OBS Name',  value: 'observer_name',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"Observer Email")) {
                    headers.push({ text: 'OBS Email',  value: 'observer_email',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"Observer Phone")) {
                    headers.push({ text: 'OBS Phne',  value: 'observer_phone',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"Observer Type")) {
                    headers.push({ text: 'OBS Type',  value: 'observer_type',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"Submitted Date")) {
                    headers.push({ text: 'Sub Date',  value: 'submitted_date',sortable: true},)
                }

                if (this.TABLE_HEADER_SHOW(customeHeader,"User Group")) {
                    headers.push({ text: 'USER GROUP',  value: 'user_group_name',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"User Group Code")) {
                    headers.push({ text: 'USER GROUP CODE',  value: 'user_group_code',sortable: true},)
                }

                //added / created 
                if (this.TABLE_HEADER_SHOW(customeHeader,"Added By")) {
                    headers.push({ text: 'ADDED BY',  value: 'user_name',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"Added At")) {
                    headers.push({ text: 'ADDED AT',  value: 'created_at',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"Updated At")) {
                    headers.push({ text: 'UPDATED AT',  value: 'updated_at',sortable: true},)
                }

                //party
                if (this.TABLE_HEADER_SHOW(customeHeader,"Party Name")) {
                    headers.push({ text: 'PARTY NAME', value: 'party_name',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"Party Short Name")) {
                    headers.push({ text: 'PARTY SHORT NAME', value: 'party_short_name',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"Short Name")) {
                    headers.push({ text: 'SHORT NAME', value: 'party_short_name',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"Party Code")) {
                    headers.push({ text: 'PARTY CODE', value: 'party_code',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"Color Code")) {
                    headers.push({ text: 'COLOR CODE', value: 'color_code',sortable: true},)
                }

                //Region
                if (this.TABLE_HEADER_SHOW(customeHeader,"Region Name")) {
                    headers.push({ text: 'REGION NAME', value: 'region_name',sortable: true},)
                } 
                if (this.TABLE_HEADER_SHOW(customeHeader,"Region Code")) {
                    headers.push({ text: 'REGION CODE', value: 'region_code',sortable: true},)
                }

                //District
                if (this.TABLE_HEADER_SHOW(customeHeader,"District Name")) {
                    headers.push({ text: 'DISTRICT NAME', value: 'district_name',sortable: true},)
                } 
                if (this.TABLE_HEADER_SHOW(customeHeader,"District Code")) {
                    headers.push({ text: 'DISTRICT CODE', value: 'district_code',sortable: true},)
                }

                //Constituency
                if (this.TABLE_HEADER_SHOW(customeHeader,"Constituency Name")) {
                    headers.push({ text: 'CONSTITUENCY NAME', value: 'constituency_name',sortable: true},)
                } 
                if (this.TABLE_HEADER_SHOW(customeHeader,"Constituency Code")) {
                    headers.push({ text: 'CONSTITUENCY CODE', value: 'constituency_code',sortable: true},)
                }

                //Ward
                if (this.TABLE_HEADER_SHOW(customeHeader,"Ward Name")) {
                    headers.push({ text: 'WARD NAME', value: 'ward_name',sortable: true},)
                } 
                if (this.TABLE_HEADER_SHOW(customeHeader,"Ward Code")) {
                    headers.push({ text: 'WARD CODE', value: 'ward_code',sortable: true},)
                }
                
                //totals
                if (this.TABLE_HEADER_SHOW(customeHeader,"Total Districts")) {
                    headers.push({ text: 'TOTAL DISTRICTS', value: 'total_district',sortable: true},)
                } 
                if (this.TABLE_HEADER_SHOW(customeHeader,"Total Constituencies")) {
                    headers.push({ text: 'TOTAL CONSTITUENCIES', value: 'total_constituencies',sortable: true},)
                } 
                if (this.TABLE_HEADER_SHOW(customeHeader,"Total Wards")) {
                    headers.push({ text: 'TOTAL WARDS', value: 'total_wards',sortable: true},)
                } 
                if (this.TABLE_HEADER_SHOW(customeHeader,"Total Centres")) {
                    headers.push({ text: 'TOTAL CENTRES', value: 'total_centres',sortable: true},)
                } 

                //Centre
                if (this.TABLE_HEADER_SHOW(customeHeader,"Centre Name")) {
                    headers.push({ text: 'CENTRE NAME', value: 'centre_name',sortable: true},)
                } 
                if (this.TABLE_HEADER_SHOW(customeHeader,"Centre Code")) {
                    headers.push({ text: 'CENTRE CODE', value: 'centre_code',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"Total Registered")) {
                    headers.push({ text: 'TOTAL REGISTERED', value: 'total_registered',sortable: true},)
                }

                //SMS 
                if (this.TABLE_HEADER_SHOW(customeHeader,"Time")) {
                    headers.push({ text: 'TIME', value: 'created_at',sortable: true},)
                } 
                if (this.TABLE_HEADER_SHOW(customeHeader,"From")) {
                    headers.push({ text: 'FROM', value: 'from',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"Message")) {
                    headers.push({ text: 'SMS', value: 'message',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"Device")) {
                    headers.push({ text: 'DEVICE', value: 'device_id',sortable: true},)
                }

                

                if (this.TABLE_HEADER_SHOW(customeHeader,"Code")) {
                    headers.push({ text: 'CODE', value: 'code',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"Start Date")) {
                    headers.push({ text: 'START_DATE', value: 'start_date',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"End Date")) {
                    headers.push({ text: 'END_DATE', value: 'end_date',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"Start Time")) {
                    headers.push({ text: 'START_TIME', value: 'start_time',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"End Time")) {
                    headers.push({ text: 'END_TIME', value: 'end_time',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"Votes")) {
                    headers.push({ text: 'VOTES', value: 'votes',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"Error")) {
                    headers.push({ text: 'ERROR', value: 'error',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"Candidates Results Code")) {
                    headers.push({ text: 'CANDIDATES RESULTS', value: 'candidates_results',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"Image Link")) {
                    headers.push({ text: 'IMAGE LINK', value: 'image_link',sortable: true},)
                }
                if (this.TABLE_HEADER_SHOW(customeHeader,"ACTION")) {
                    headers.push({ text: 'ACTION',align: 'center', value: 'action',sortable: false })
                }
              return headers
            },
            TABLE_HEADER_SHOW(headers,name){  
                if (!headers) {return false}
                if (!(headers instanceof Array)) { 
                  return false
                } 
                
                let hd = headers.find(item=>{
                    return item.name == name
                })
                if (!hd) {return false} 
                return hd.show
            },
            TABLE_HEADER_SELECTOR(headers,index){   
                if (!headers) {return}
                if (!index) {return} 
                let hd = headers.hasOwnProperty(index)
                if (hd) {
                  headers[index].show = !headers[index].show
                }
            },

            //CODE
            CODE_IS_OK(array){
              if(!array){return false}
              let isOk = true
              array.forEach(element => {
                let code = element.code
                if (!code) {
                  isOk = false
                }else if (code ==='') {
                  isOk = false
                }else if (code ==='0') {
                  isOk = false
                }else if (code ===0) {
                  isOk = false
                }
              });
              return isOk
            },
            CODE_IS_AUTO(array){
              if(!array){return false}
              let isAuto = true
              let autoArray  = this.CODE_AUTO_GENERATE(array)
              
              for (const index in array) {
                let e_array = array[index]
                let e_autoArray = autoArray[index]
                let code = e_array?e_array.code:null
                let autoCode = e_autoArray?e_autoArray.code:null

                if (code !== autoCode) {
                  isAuto = false
                } 
              }

              return isAuto
            },
            CODE_AUTO_GENERATE(array){
              if(!array){return null}

              let newArray = []
              let code = 0
              array.forEach(element => {
                code = code+1
                newArray.push({
                  ...element,
                  code:code
                })
              });
              return newArray
            },
            CODE_GET_FIRST(array){
              if(!array){return 0}
              let first = 0
              let number = 0
              array.forEach(element => {
                number = number+1
                let code = element.code*1
                if (number === 1 ) {
                  first = code
                }
                
                if (code < first) {
                  first = code
                }
              });

              return first
            },
            CODE_GET_LAST(array){
              if(!array){return 0}
              let last = 0
              
              array.forEach(element => { 
                let code = element.code*1
                if (code > last) {
                  last = code
                }
              }); 
              return last
            },
            CODE_CHECK(array,code){
              if(!array){return false}
              if(!code){return false}
              
              let check = false 
              
              array.forEach(element => { 
                if (element.code ===code) {
                  check = true
                }
              }); 

              return check
            }, 
            
            //GENDER
            GENDER_NAME(name){
              let male = "male"
              let female = "female"
              if (!name) {return female}
              let int = name*1
              let string = (''+name).toUpperCase()  
              if (int===1) {
                return male
              }else if (string==="MALE") {
                return male
              }else{
                return female
              } 
            },
            GENDER_VALUE(name){
              let male = 1
              let female = 0
              if (!name) {return female}
              let int = name*1
              let string = (''+name).toUpperCase()  
              
              if (int===1) {
                return male
              }else if (string==="MALE") {
                return male
              }else{
                return female
              } 
            },


            //JOIN TABLES
            JOIN_OBSERVERS(observers){
              if (!observers) {
                  return null
              }

              let joinedObserver = []
              let number = 0
              observers.forEach(ds => {
                  let observer_code = ds.code 
                  let uid = ds.uid
                  number = number + 1

                  //find User
                  let user = this.$store.getters.getUserByUid(uid)
                  let user_name =user?user.name:null 

                  //JOIN
                  let jn_party = {
                      ...ds,
                      first_name:this.TEXT_UP1(ds.first_name),
                      last_name:this.TEXT_UP1(ds.last_name),
                      email:this.TEXT_UP0(ds.email),
                      gender: this.TEXT_UP1(this.GENDER_NAME(ds.gender)),
                      no:number,
                      created_at:this.convertDate(ds.created_at),
                      updated_at:this.convertDate(ds.updated_at),
                      user_name:this.TEXT_UP11(user_name),
                  }
                  joinedObserver.push(jn_party)
              });
              return joinedObserver
            },
            JOIN_CANDIDATES(candidates){
              if (!candidates) {
                  return null
              }

              let joinedCandidates = []
              let number = 0
              candidates.forEach(ds => {
                let uid = ds.uid
                  let candidate_code = ds.code
                  let party_code = ds.party_code
                  number = number + 1

                  //find 
                  let party = this.$store.getters.getPartyByCode(party_code)
                  let party_name = party?party.name:"?:"+party_code
                  let party_short_name = party?party.party_short_name:"?:"+party_code

                  //find User
                  let user = this.$store.getters.getUserByUid(uid)
                  let user_name =user?user.name:null 

                  //JOIN
                  let jn_candate = {
                      ...ds,
                      name:this.TEXT_UP11(ds.name),
                      gender:this.TEXT_UP11(ds.gender),
                      no:number,
                      party_code:party_code,
                      party_name:this.TEXT_UP11(party_name),
                      party_short_name:this.TEXT_UP(party_short_name),
                      created_at:this.convertDate(ds.created_at),
                      updated_at:this.convertDate(ds.updated_at),
                      user_name:this.TEXT_UP11(user_name), 
                      party:party
                  }
                  joinedCandidates.push(jn_candate)
              });
              return joinedCandidates
            },
            JOIN_PARTIES(parties){
              if (!parties) {
                  return null
              }

              let joinedParties = []
              let number = 0
              parties.forEach(ds => {
                  let party_code = ds.code  
                  let uid = ds.uid
                  number = number+1

                  //find User
                  let user = this.$store.getters.getUserByUid(uid)
                  let user_name =user?user.name:null 

                  //find 
                  let candidate = this.$store.getters.getCandidateByPartyCode(party_code)
                  let candidate_name =candidate?candidate.name:"?:"+party_code 
                  let candidate_code =candidate?candidate.code:"?:"+party_code 

                  //JOIN
                  let jn_party = {
                      ...ds,
                      no:number,
                      name:this.TEXT_UP11(ds.name),
                      short_name:this.TEXT_UP(ds.short_name),
                      created_at:this.convertDate(ds.created_at),
                      updated_at:this.convertDate(ds.updated_at),
                      candidate_name:this.TEXT_UP11(candidate_name),
                      candidate_code:candidate_code,
                      user_name:this.TEXT_UP11(user_name),
                      user_code:uid
 
                  }
                  joinedParties.push(jn_party)
              });
              return joinedParties
            }, 
            JOIN_REGIONS(regions){
              if (!regions) {
                  return null
              }

              let joinedRegions = []
              let number = 0
              regions.forEach(ds => {
                  let region_code = ds.code 
                  let uid = ds.uid
                  number = number+1

                  //find User
                  let user = this.$store.getters.getUserByUid(uid)
                  let user_name =user?user.name:null 

                  //find 
                   

                  //JOIN
                  let jn_regions = {
                      ...ds,
                      no:number,
                      name:this.TEXT_UP11(ds.name),
                      created_at:this.convertDate(ds.created_at),
                      updated_at:this.convertDate(ds.updated_at),
                      user_name:this.TEXT_UP11(user_name),
 
                  }
                  joinedRegions.push(jn_regions)
              });
              return joinedRegions
            },
            JOIN_DISTRICTS(districts){
              if (!districts) {
                  return null
              }

              let joinedDistricts = []
              let number = 0
              districts.forEach(ds => {
                  let district_code = ds.code
                  let region_code = ds.region_code
                  let uid = ds.uid
                  number = number+1

                  //find User
                  let user = this.$store.getters.getUserByUid(uid)
                  let user_name =user?user.name:null 

                  //find 
                  let region = this.$store.getters.getRegionByCode(region_code)
                  let region_name = region?region.name:null

                  //JOIN
                  let jn_district = {
                      ...ds,
                      no:number,
                      name:this.TEXT_UP11(ds.name),
                      created_at:this.convertDate(ds.created_at),
                      updated_at:this.convertDate(ds.updated_at),
                      user_name:this.TEXT_UP11(user_name),

                      region_code:region_code,
                      region_name:this.TEXT_UP11(region_name), 
                  }
                  joinedDistricts.push(jn_district)
              });
              return joinedDistricts
            },
            JOIN_CONSTITUENCIES(constituencies){
              if (!constituencies) {
                  return null
              }

              let joinedConstituencies = []
              let number = 0
              constituencies.forEach(cs => {
                  let constituency_code = cs.code
                  let district_code = cs.district_code
                  let uid = cs.uid
                  number = number+1

                  //find User
                  let user = this.$store.getters.getUserByUid(uid)
                  let user_name =user?user.name:null 

                  //find district
                  let district = this.$store.getters.getDistrictByCode(district_code)
                  let district_name = district?district.name:"?:"+district_code
                  let region_code = district?district.region_code:null

                  //find constituency
                  let region = this.$store.getters.getRegionByCode(region_code)
                  let region_name = region?region.name:"?:"+region_code

                  //JOIN
                  let jn_constituency = {
                      ...cs,
                      no:number,
                      name:this.TEXT_UP11(cs.name),
                      user_name:this.TEXT_UP11(user_name),
                      created_at:this.convertDate(cs.created_at),

                      district_name:this.TEXT_UP11(district_name),
                      district_code:district_code,
                       
                      region_code:region_code,
                      region_name:this.TEXT_UP11(region_name),
                       
                  }
                  joinedConstituencies.push(jn_constituency)
              });
              return joinedConstituencies
            },
            JOIN_WARDS(wards){
              let joinedWard = []
              let number = 0
              wards.forEach(wd => {
                  let ward_code = wd.code
                  let constituency_code = wd.constituency_code
                  let uid = wd.uid
                  number = number+1


                  //find User
                  let user = this.$store.getters.getUserByUid(uid)
                  let user_name =user?user.name:null 

                  //find constituency
                  let constituency = this.$store.getters.getConstituencyByCode(constituency_code)
                  let constituency_name = constituency?constituency.name:"?:"+constituency_code
                  let district_code = constituency?constituency.district_code:null

                  //find district
                  let district = this.$store.getters.getDistrictByCode(district_code) 
                  let district_name = district?district.name:"?:"+district_code
                  let region_code = district?district.region_code:null

                  //find region
                  let region = this.$store.getters.getRegionByCode(region_code)
                  let region_name = region?region.name:"?:"+region_code 
 
                  //JOIN
                  let ward = {
                      ...wd,
                      name:this.TEXT_UP11(wd.name),
                      no:number,
                      created_at:this.convertDate(wd.created_at),
                      user_name:this.TEXT_UP11(user_name),

                      region_code:region_code,
                      region_name:this.TEXT_UP11(region_name),
                       
                      district_code:district_code,
                      district_name:this.TEXT_UP11(district_name),
                       
                      constituency_code:constituency_code,
                      constituency_name:this.TEXT_UP11(constituency_name), 
                  }
                  joinedWard.push(ward) 
              });

              return joinedWard
            },
            JOIN_CENTRES(centres){
              let joinedCentres = []
              let number = 0
              centres.forEach(ct => {
                  number = number+1 
                  let centre_code = ct.code
                  let ward_code = ct.ward_code
                  let uid = ct.uid

                  //find User
                  let user = this.$store.getters.getUserByUid(uid)
                  let user_name =user?user.name:null

                  //find ward
                  let ward = this.$store.getters.getWardByCode(ward_code) 
                  let ward_name =ward?ward.name:"?:"+ward_code
                  let constituency_code =ward?ward.constituency_code:null

                  //find constituency
                  let constituency = this.$store.getters.getConstituencyByCode(constituency_code)
                  let constituency_name = constituency?constituency.name:"?:"+constituency_code
                  let district_code = constituency?constituency.district_code:null

                  //find district
                  let district = this.$store.getters.getDistrictByCode(district_code) 
                  let district_name = district?district.name:"?:"+district_code
                  let region_code = district?district.region_code:null

                  //find region
                  let region = this.$store.getters.getRegionByCode(region_code)
                  let region_name = region?region.name:"?:"+region_code

                  //JOIN
                  let centre = {
                      ...ct,
                      name:this.TEXT_UP11(ct.name),
                      created_at:this.convertDate(ct.created_at),
                      user_name:this.TEXT_UP11(user_name),

                      region_code:region_code,
                      region_name:this.TEXT_UP11(region_name), 

                      district_code:district_code,
                      district_name:this.TEXT_UP11(district_name), 

                      constituency_code:constituency_code,
                      constituency_name:this.TEXT_UP11(constituency_name),
                       
                      ward_code:ward_code,
                      ward_name:this.TEXT_UP11(ward_name),
                       
                      wardSelectorName:ward?ward.i+". "+ward.name:''
                  }
                  joinedCentres.push(centre) 
              }); 
              return joinedCentres
            }, 
            JOIN_RESULTS(results,resultsDetails){  
              
              if (!results) { return null } 

              let joinedResults = []
              let no = 0
              results.forEach(item => {
                no = no+1
                let results_details_key = item.results_details_key
                let candidate_code = item.candidate_code
                

                //find candidate
                let candidate = this.$store.getters.getCandidateByCode(candidate_code)
                let candidate_name = candidate?candidate.name:'?:'+candidate_code
                let candidate_gender = candidate?candidate.gender:'?:'+candidate_code
                let party_code = candidate?candidate.party_code:''
                if (candidate_code==="NULL&VOID") {
                  candidate_name = "NULL&VOID"
                }else if (candidate_code==="VALID-VOTES") {
                  candidate_name = "VALID-VOTES"
                }

                //find candidate
                let party = this.$store.getters.getPartyByCode(party_code)
                let party_name = party?party.name:'?:'+party_code
                let party_short_name = party?party.party_short_name:'?:'+party_code
                if (candidate_code==="NULL&VOID") {
                  party_name = "NULL&VOID"
                  party_short_name = "NULL&VOID"
                }else if (candidate_code==="VALID-VOTES") {
                  party_name = "VALID-VOTES"
                  party_short_name = "VALID-VOTES"
                }

                //find detail
                function getResultsDetailsByKey(key){
                  if(!resultsDetails){return null}
                  return resultsDetails.find(res=>{
                    return res.key == key
                  })
                }
                let resultsDetail = getResultsDetailsByKey(results_details_key) 
                
                let uid = resultsDetail?resultsDetail.uid:''
                let user_type = resultsDetail?resultsDetail.user_type:''

                let region_code = resultsDetail?resultsDetail.region_code:null
                let district_code = resultsDetail?resultsDetail.district_code:null
                let constituency_code = resultsDetail?resultsDetail.constituency_code:null
                let ward_code = resultsDetail?resultsDetail.ward_code:null
                let centre_code = resultsDetail?resultsDetail.centre_code:null
                
                //find observer
                let user =user_type === "admin"? this.$store.getters.getUserByUid(uid):this.$store.getters.getObserverByCode(uid) 
                let user_name = user?user.name:'--' 
                let userEmail = user?user.email:'--' 
                let userPhone = user?user.phone:'--' 
                let user_name_type = user_type === "admin"?"AD":"OB"

                //find REGION
                let region = this.$store.getters.getRegionByCode(region_code)
                let region_name = region?region.name:'?:'+region_code 

                //find district
                let district = this.$store.getters.getDistrictByCode(district_code)
                let district_name = district?district.name:'?:'+district_code

                //find constituency
                let constituency = this.$store.getters.getConstituencyByCode(constituency_code)
                let constituency_name = constituency?constituency.name:'?:'+constituency_code  

                //find ward
                let ward = this.$store.getters.getWardByCode(ward_code)
                let ward_name = ward?ward.name:'?:'+ward_code

                //find centre
                let centre = this.$store.getters.getCentreByCode(centre_code)
                let centre_name = centre?centre.name:'?:'+centre_code

                

                let jn_Result = {
                  ...item,
                  no:no, 
                  created_at:this.convertDate(resultsDetail?resultsDetail.created_at:null),
                  update_at:this.convertDate(resultsDetail?resultsDetail.update_at:null),

                  party:party,
                  party_name : this.TEXT_UP11(party_name),
                  party_short_name:this.TEXT_UP(party_short_name),
                  party_code : party_code, 

                  //candidate
                  candidate:candidate,
                  candidate_gender:this.TEXT_UP11(candidate_gender),
                  candidate_name:this.TEXT_UP11(candidate_name),
                  candidate_code:candidate_code,
                  
                  //User 
                  observer_name : this.TEXT_UP11(user_name),
                  observer_type : this.TEXT_UP11(user_type),
                  observer_email : this.TEXT_UP0(userEmail), 
                  observer_phone : userPhone,

                  //region
                  region:region,
                  region_name:this.TEXT_UP11(region_name),
                  region_code:region_code,

                  //district
                  district:district,
                  district_name:this.TEXT_UP11(district_name),
                  district_code:district_code,

                  //constituency
                  constituency:constituency,
                  constituency_name:this.TEXT_UP11(constituency_name),
                  constituency_code:constituency_code,

                  //ward
                  ward:ward,
                  ward_name:this.TEXT_UP11(ward_name),
                  ward_code:ward_code,

                  //centre
                  centre:centre,
                  centre_name:this.TEXT_UP11(centre_name),
                  centre_code:centre_code,

                } 
                joinedResults.push(jn_Result)
              });
 
              return joinedResults
            },
            JOIN_XL_RESULTS(results,type){ 
              let candidates = this.candidates
              if (!results) { return null }  
              if (!candidates) { return null }   
              //CANDIDATES DATA
              let newResults = []
              let number = 0
              results.forEach(rst => { 
                //LOCATION DATA
                number = number+1
                let location = null
                let in_location = null
                if (type === "district") {
                  in_location = rst.district
                  location = this.$store.getters.getDistrictByName(in_location)  
                }else if (type === "constituency") {
                  in_location = rst.constituency
                  location = this.$store.getters.getConstituencyByName(in_location) 
                }else if (type === "ward") {
                  in_location = rst.ward
                  location = this.$store.getters.getWardByName(in_location) 
                }else if (type === "centre") {
                  in_location = rst.centre
                  location = this.$store.getters.getCentreByName(in_location) 
                } 
                let newResultsDetails = this.JOIN_LOCATION(location,type,in_location)   
                
                
                //CANDIDATES DATA
                let newDataSet = []
                let candidate_results = " ["
                let index = 0
                let size = candidates.length
                candidates.forEach(cand => {
                  index = index+1
                  let candidate_code = cand.code
                  let party_code = cand.party_code
                  let party = this.$store.getters.getPartyByCode(party_code)
                  let party_short_name = party?party.party_short_name:"?:"+party_code
                  let votes = rst[candidate_code]?rst[candidate_code]:0

                  //add candidate data
                   
                  newDataSet.push({ 
                    candidate_code : candidate_code,
                    party_code : party_code,
                    party_short_name : party_short_name,
                    votes : votes,
                    level:type
                  }) 
                  let split = index<size?"] -- [":"]"
                  candidate_results = candidate_results+candidate_code+"="+votes+split
                  //candidate_results = size
                });
                newResults.push({
                  no:number,
                  form_type:rst.form_type,
                  form_number:rst.form_number,
                  results:newDataSet,
                  ...newResultsDetails, 
                  candidates_results : candidate_results
                })
                
              }); 
              let resultsWithError = []
              newResults.forEach(element => {
                if (element.error==true) {
                  resultsWithError.push({
                    no:element.no,
                    name:element.error_location,
                    type:element.error_location_type
                  })
                }
              });
              return {
                results:newResults,
                errors:resultsWithError,
                level:type
              }
            },
            JOIN_QUESTIONS(question,type){
              if(!question){return null}

              let Jn_question = []
              let number = 0
              question.forEach(it => {
                let uid = it.uid
                let user = this.$store.getters.getUserByUid(uid)
                let user_name = user?user.name:""
                number = number+1

                // 
                let ques = {
                  ...it,
                  no:number,
                  user_name:user_name,
                  created_at:this.convertDate(it.created_at),
                  update_at:this.convertDate(it.updated_at)
                }

                //CHECK LIST
                if (type==="checklist") {
                  //get codes
                  let question_category_code = it.question_category_code
                  let question_stage_code = it.question_stage_code
                  let question_type_code = it.question_type_code
                  let question_timeline_code = it.question_timeline_code
                  
                  //get by code
                  let question_category = this.$store.getters.getQuestionCategoryByCode(question_category_code)
                  let question_stage = this.$store.getters.getQuestionStageByCode(question_stage_code)
                  let question_type = this.$store.getters.getQuestionTypeByCode(question_type_code)
                  let question_timeline = this.$store.getters.getQuestionTimelineByCode(question_timeline_code)

                  //get names'
                  let question_category_name = question_category?question_category.name:''
                  let question_stage_name = question_stage?question_stage.name:'?:'+question_stage_code
                  let question_type_name = question_type?question_type.name:'?:'+question_type_code
                  let question_timeline_name = question_timeline?question_timeline.name:'?:'+question_timeline_code

                  //get time'
                  let question_start_date = question_stage?question_stage.start_date:''
                  let question_end_date = question_stage?question_stage.end_date:''
                  let question_start_time = question_stage?question_stage.start_time:''
                  let question_end_time = question_stage?question_stage.end_time:''

                  

                  //join to the question
                  ques = {
                    ...ques, 
                    // name:this.TEXT_UP(ques.name),
                    question_explanation:  ques.question_has_explanation?"Yes":"No",

                    question_category_name:this.TEXT_UP11(question_category_name),
                    question_stage_name:this.TEXT_UP11(question_stage_name),
                    question_type_name:this.TEXT_UP11(question_type_name),
                    question_timeline_name:this.TEXT_UP11(question_timeline_name),

                    start_date:question_start_date,
                    end_date:question_end_date,
                    start_time:question_start_time,
                    end_time:question_end_time,

                  }
                  
                }
                //join
                Jn_question.push(ques)
              });
              return Jn_question
            },
            JOIN_LOCATION(location,type,in_location){ 
              let data = {
                error:false,
                error_location:in_location,
                error_location_type:type
              }
              if (!location) { 
                return {
                  ...data,
                  error:true
                } 
              } 
              if (!type) {  
                return {
                  ...data,
                  error:true
                } 
               } 
              let districts = this.districts
              let constituencies = this.constituencies
              let wards = this.wards
              let centres = this.centres
              let candidates = this.candidates

              //CANDIDATES DATA
              let newDataSet = {}
              let region_code = null
              let district = null
              let constituency = null
              let ward = null
              let centre = null

              let district_code = null
              let constituency_code = null
              let ward_code = null
              let centre_code = null

              //LOCATION DATA
              if (type === "district") {
                district = location
                district_code = district?district.code:null
                 
              }else if (type === "constituency") {
                constituency = location 
                constituency_code = constituency?constituency.code:null 
                district_code = constituency?constituency.district_code:null
                district = this.$store.getters.getDistrictByCode(district_code)
              } 
              else if (type === "ward") {
                ward = location  
                ward_code = wards?wards.code:null 
                constituency_code = ward?ward.constituency_code:null
                constituency = this.$store.getters.getConstituencyByCode(constituency_code)
                district_code = constituency?constituency.district_code:null
                district = this.$store.getters.getDistrictByCode(district_code)
              }else if (type === "centre") {
                centre = location 
                ward_code = centre?centre.ward_code:null
                ward = this.$store.getters.getWardByCode(ward_code)
                constituency_code = ward?ward.constituency_code:null
                constituency = this.$store.getters.getConstituencyByCode(constituency_code)
                district_code = constituency?constituency.district_code:null
                district = this.$store.getters.getDistrictByCode(district_code)
                
              }   

              region_code= district?district.region_code:null
              district_code = district?district.code:null
              constituency_code = constituency?constituency.code:null
              ward_code = ward?ward.code:null
              centre_code = centre?centre.code:null

              return  {
                ...data,
                region_code:region_code,
                district :district,
                district_code :district_code,
                district_name :district?district.name:null,
                constituency: constituency,
                constituency_code:constituency_code,
                constituency_name:constituency?constituency.name:null,
                ward:ward,
                ward_code:ward_code,
                ward_name:ward?ward.name:null,
                centre:centre,
                centre_code:centre_code,
                centre_name:centre?centre.name:null,
                tracking_key:(region_code?region_code:"--")+";"+(district_code?district_code:"--")+";"+(constituency_code?constituency_code:"--")+";"+(ward_code?ward_code:"--")+";"+(centre_code?centre_code:"--"),
              }
            },
            JOIN_USER_GROUP(userGroup){
              if (!userGroup) {
                  return null
              }

              let joinUserGroup = []
              let number = 0
              userGroup.forEach(ds => { 
                  let uid = ds.uid
                  number = number+1

                  //find User
                  let user = this.$store.getters.getUserByUid(uid)
                  let user_name =user?user.name:null 
 

                  //JOIN
                  let jn_userGroup = {
                      ...ds,
                      no:number,
                      name:this.TEXT_UP(ds.name), 
                      created_at:this.convertDate(ds.created_at),
                      updated_at:this.convertDate(ds.updated_at), 
                      user_name:this.TEXT_UP11(user_name),
                      user_code:uid 
                  }
                  joinUserGroup.push(jn_userGroup)
              });
              return joinUserGroup
            }, 
            JOIN_UDS(uds){
              if (!uds) {
                  return null
              }

              let joinUds = []
              let number = 0
              uds.forEach(ds => { 
                  let uid = ds.uid
                  let ug_code = ds.user_group_code
                  number = number+1

                  //getUserGroupByCode
                  let userGroup = this.$store.getters.getUserGroupByCode(ug_code)
                  let user_group_name =userGroup?userGroup.name:"?:"+ug_code
                  let permissions =userGroup?userGroup.permissions:null 
                  if (ds.email==="admin@tidziwe.com") {
                    user_group_name = "Super Admin" 
                    permissions = this.$store.getters.getPermissionsTrue
                  }

                  //find User
                  let user = this.$store.getters.getUserByUid(uid)
                  let user_name =user?user.name:null 

                  //JOIN
                  let jn_uds = {
                      ...ds,
                      no:number,
                      name:this.TEXT_UP11(ds.name), 
                      created_at:this.convertDate(ds.created_at),
                      updated_at:this.convertDate(ds.updated_at), 
                      user_name:this.TEXT_UP11(user_name),
                      user_code:uid,
                      user_group_name:this.TEXT_UP(user_group_name),
                      permissions:permissions
                  }
                  joinUds.push(jn_uds)
              }); 
              return joinUds
            }, 
            JOIN_UD(ud){
              if (!ud) {
                  return null
              }
 
              let uid = ud.uid
              let ug_code = ud.user_group_code 

              //getUserGroupByCode
              let userGroup = this.$store.getters.getUserGroupByCode(ug_code)
              let user_group_name =userGroup?userGroup.name:"?:"+ug_code
              let permissions =userGroup?userGroup.permissions:null 
              if (ud.email==="admin@tidziwe.com") {
                user_group_name = "Super Admin" 
                permissions = this.$store.getters.getPermissionsTrue
              }

              //find User
              let user = this.$store.getters.getUserByUid(uid)
              let user_name =user?user.name:null 

              //JOIN
              let jn_uds = {
                  ...ud, 
                  name:this.TEXT_UP11(ud.name), 
                  created_at:this.convertDate(ud.created_at),
                  updated_at:this.convertDate(ud.updated_at), 
                  user_name:this.TEXT_UP11(user_name),
                  user_code:uid,
                  user_group_name:this.TEXT_UP(user_group_name),
                  permissions:permissions
              }  
              return jn_uds
            }, 
            JOIN_OBSERVER_LOCATION(location){  
              if (!location) { 
                return null
              }  
              let newLocation = [] 
              let number = 0
              location.forEach(element => {
                number = number+1
                let region = null
                let district = null
                let constituency = null
                let ward = null
                let centre = null
                let candidate = null
  
                //CANDIDATES DATA 
                let region_code = element.region_code 
                let district_code = element.district_code
                let constituency_code = element.constituency_code
                let ward_code = element.ward_code
                let centre_code = element.centre_code
  
                region = this.$store.getters.getRegionByCode(region_code)
                district = this.$store.getters.getDistrictByCode(district_code)
                constituency = this.$store.getters.getConstituencyByCode(constituency_code) 
                ward = this.$store.getters.getWardByCode(ward_code) 
                centre = this.$store.getters.getCentreByCode(centre_code) 
  
                newLocation.push({
                  ...element,
                  no : number,
                  region_name:region?region.name:null,
                  district :district, 
                  district_name :district?district.name:null,
                  constituency: constituency, 
                  constituency_name:constituency?constituency.name:null,
                  ward:ward, 
                  ward_name:ward?ward.name:null,
                  centre:centre, 
                  centre_name:centre?centre.name:null,
                  tracking_key:(region_code?region_code:"--")+";"+(district_code?district_code:"--")+";"+(constituency_code?constituency_code:"--")+";"+(ward_code?ward_code:"--")+";"+(centre_code?centre_code:"--"),
                }) 
              });
              return newLocation
            }, 
            JOIN_USER_LOCATION(location){  
              if (!location) { 
                return null
              }  
              let newLocation = [] 
              let number = 0
              location.forEach(element => {
                number = number+1
                let region = null
                let district = null
                let constituency = null
                let ward = null
                let centre = null
                let candidate = null
  
                //CANDIDATES DATA 
                let region_code = element.region_code 
                let district_code = element.district_code
                let constituency_code = element.constituency_code
                let ward_code = element.ward_code
                let centre_code = element.centre_code
  
                region = this.$store.getters.getRegionByCode(region_code)
                district = this.$store.getters.getDistrictByCode(district_code)
                constituency = this.$store.getters.getConstituencyByCode(constituency_code) 
                ward = this.$store.getters.getWardByCode(ward_code) 
                centre = this.$store.getters.getCentreByCode(centre_code) 
  
                newLocation.push({
                  ...element,
                  no : number,
                  region_name:region?region.name:null,
                  district :district, 
                  district_name :district?district.name:null,
                  constituency: constituency, 
                  constituency_name:constituency?constituency.name:null,
                  ward:ward, 
                  ward_name:ward?ward.name:null,
                  centre:centre, 
                  centre_name:centre?centre.name:null,
                  tracking_key:(region_code?region_code:"--")+";"+(district_code?district_code:"--")+";"+(constituency_code?constituency_code:"--")+";"+(ward_code?ward_code:"--")+";"+(centre_code?centre_code:"--"),
                }) 
              });
              return newLocation
            }, 
            // JOIN_SMS(sms){
            //   if (!sms) {
            //     sms = this.sms
            //   }
            //   if(!sms){return null}

            //   let joinedSMS = []
            //   let number = 0
            //   sms.forEach(sm => {
            //       number = number+1 
            //       let sent_timestamp = sm.sent_timestamp/1000
            //       let from = this.PHONE_NUMBER(sm.from)
            //       let message = sm.message  

            //       //calculate id
            //       let centre_code = 0
            //       if(message) {
            //         if (message.indexOf(",")!=-1) {
            //           centre_code = message?message.split(",")[0]:0
            //         }
            //       }

            //       //calculate observer
            //       let observer = this.observerByNumber(from)
            //       let observer_name = observer?observer.first_name+' '+observer.last_name:"?:"

            //       //find centre
            //       let centre = this.$store.getters.getCentreByCode(centre_code)
            //       let centre_name = centre?centre.name:'?:'+centre_code
            //       let ward_code = centre?centre.ward_code:null

            //       //find ward
            //       let ward = this.$store.getters.getWardByCode(ward_code)
            //       let ward_name = ward?ward.name:'?:'+ward_code
            //       let constituency_code = ward?ward.constituency_code:null

            //       //find constituency
            //       let constituency = this.$store.getters.getConstituencyByCode(constituency_code)
            //       let constituency_name = constituency?constituency.name:'?:'+constituency_code 
            //       let district_code = constituency?constituency.district_code:null

            //       //find district
            //       let district = this.$store.getters.getDistrictByCode(district_code)
            //       let district_name = district?district.name:'?:'+district_code
            //       let region_code = district?district.region_code:null

            //       //find region
            //       let region = this.$store.getters.getRegionByCode(region_code)
            //       let region_name = region?region.name:"?:"+region_code

                   

                  

            //       //JOIN
            //       let mg = {
            //           ...sm, 
            //           no : number,
            //           centre_code:centre_code,
            //           phone_number:from,
            //           observer:observer,
            //           observer_name:observer_name,
            //           centre:centre,
            //           centre_name:centre_name,
            //           ward:ward,
            //           ward_code:ward_code,
            //           ward_name:ward_name,
            //           constituency:constituency,
            //           constituency_code:constituency_code,
            //           constituency_name:constituency_name,
            //           district:district,
            //           district_code:district_code,
            //           district_name:district_name,
            //           region:region,
            //           region_code:region_code,
            //           region_name:region_name, 
            //           created_at:this.TIME_TS(sent_timestamp), 
            //       }
            //       joinedSMS.push(mg) 
            //   }); 
            //   return joinedSMS
            // }, 
            JOIN_SMS(sms){
              if (!sms) {
                sms = this.sms
              }
              if(!sms){return null}

              let joinedSMS = []
              let number = 0
              sms.forEach(sm => {
                  number = number+1 
                  let sent_timestamp = sm.sent_timestamp/1000
                  let from = this.PHONE_NUMBER(sm.from)
                  let message = sm.message  
                  let district_code = sm.district_code  
                  let question_code = sm.question_code  

                  //calculate id
                   

                  //calculate observer
                  let observer = this.observerByNumber(from)
                  let observer_name = observer?observer.first_name+' '+observer.last_name:"?:" 

                  //find district
                  let district = this.$store.getters.getDistrictByCode(district_code)
                  let district_name = district?district.name:'?:'+district_code
                  let region_code = district?district.region_code:null
                  
                  //find district
                  // let question = this.$store.getters.getQuestionChecklistByCode(question_code)
                  // let question_name = question?question.name:'?:'+question_code
                  // let question_number = question?question.question_number:'?:'+question_code 

                  //find region
                  let region = this.$store.getters.getRegionByCode(region_code)
                  let region_name = region?region.name:"?:"+region_code
 
                  

                  //JOIN
                  let mg = {
                      ...sm, 
                      no : number, 
                      phone_number:from,
                      observer:observer,
                      observer_name:observer_name,
                      
                      // question:question,
                      // question_number:question_number,
                      // question_name:question_name,
                       
                      district:district,
                      district_code:district_code,
                      district_name:district_name,
                      region:region,
                      region_code:region_code,
                      region_name:region_name, 
                      created_at:this.TIME_TS(sent_timestamp), 
                  }
                  joinedSMS.push(mg) 
              }); 
              return joinedSMS
            }, 
            
            //GROUP
            GROUP_RESULTS(results,type,resultsType){
              if (!results) {return null}
              if (!type) {return results}

              let items = []
              let TOTAL = 0
              let NUMBER = 0
              if (type.toUpperCase()==="Candidates".toUpperCase()) {
                let candidates = []

                results.forEach(it => {
                  let candidate_code = it.candidate_code
                  let index = candidates.findIndex(ca=> ca.code === candidate_code)
                  let candidate = this.$store.getters.getCandidateByCode(candidate_code)
                  let votes = (it.votes)*1

                  TOTAL = TOTAL+votes
                  NUMBER = NUMBER+1
                  
                  if (index===-1) {
                    candidates.push({
                      name:candidate?'':candidate_code,
                      code:candidate?'':candidate_code,
                      ...candidate,
                      totalVotes:votes,
                      number:1
                    })
                  }else{
                    candidates[index].totalVotes = candidates[index].totalVotes+votes
                    candidates[index].number = candidates[index].number+1
                  }
                });
                
                items = {
                    TYPE:type,
                    TOTAL:TOTAL,
                    NUMBER:NUMBER,
                    items:candidates
                }
              }else if (type.toUpperCase()==="regions".toUpperCase()) {
                let regions = [] 
                results.forEach(it => {
                  let results_details_key = it.results_details_key
                  let resultsDetails = this.$store.getters.getResultsDetailsByKey(results_details_key,resultsType)
                  let region_code = resultsDetails?resultsDetails.region_code:null
                  let region = this.$store.getters.getRegionByCode(region_code)
                  
                  let index = regions.findIndex(ca=> ca.code === region_code)
                  let votes = (it.votes)*1

                  TOTAL = TOTAL+votes
                  NUMBER = NUMBER+1
                  
                  if (index===-1) {
                    regions.push({
                      name:region?'':region_code,
                      code:region?'':region_code,
                      ...region,
                      totalVotes:votes,
                      number:1
                    })
                  }else{
                    regions[index].totalVotes = regions[index].totalVotes+votes
                    regions[index].number = regions[index].number+1
                  }
                });
                
                items = {
                    TYPE:type,
                    TOTAL:TOTAL,
                    NUMBER:NUMBER,
                    items:regions
                }
              }else if (type.toUpperCase()==="districts".toUpperCase()) {
                let districts = []

                results.forEach(it => {
                  let results_details_key = it.results_details_key
                  let resultsDetails = this.$store.getters.getResultsDetailsByKey(results_details_key,resultsType)
                  let district_code = resultsDetails?resultsDetails.district_code:null
                  let district = this.$store.getters.getDistrictByCode(district_code)
                  
                  let index = districts.findIndex(ca=> ca.code === district_code)
                  let votes = (it.votes)*1

                  TOTAL = TOTAL+votes
                  NUMBER = NUMBER+1
                  
                  if (index===-1) {
                    districts.push({
                      name:district?'':district_code,
                      code:district?'':district_code,
                      ...district,
                      totalVotes:votes,
                      number:1
                    })
                  }else{
                    districts[index].totalVotes = districts[index].totalVotes+votes
                    districts[index].number = districts[index].number+1
                  }
                });
                
                items = {
                    TYPE:type,
                    TOTAL:TOTAL,
                    NUMBER:NUMBER,
                    items:districts
                }
              }
              return items 
            },

            //CALCULATE 
            CALCULATE_PLUS(resultsType){
              let results = this.results(resultsType)
              let resultsPlus = []
              if (!results) {return null}   
              
              //ADD DETAILS
              results.forEach(it => {
                let detail = this.$store.getters.getResultsDetailsByKey(it.results_details_key,resultsType)
                if (detail) {
                  resultsPlus.push({
                    ...it,
                    ...detail
                  })
                }
              }); 
             return resultsPlus 
            },
            CALCULATE_PLUS_PLUS(resultsType){
              let results = this.results(resultsType)
              let resultsPlus = []
              if (!results) {return null}  

              //ADD DETAILS
              results.forEach(it => {
                let detail = this.$store.getters.getResultsDetailsByKey(it.results_details_key,resultsType)
                let region_code = detail?detail.region_code:null
                let district_code = detail?detail.district_code:null
                let constituency_code = detail?detail.constituency_code:null
                let ward_code = detail?detail.ward_code:null
                let centre_code = detail?detail.centre_code:null

                //find
                let region = this.$store.getters.getRegionByCode(region_code)
                let district = this.$store.getters.getDistrictByCode(district_code)
                let constituency = this.$store.getters.getConstituencyByCode(constituency_code)
                let ward = this.$store.getters.getWardByCode(ward_code)
                let centre = this.$store.getters.getCentreByCode(centre_code)
                
                //name
                let region_name = region?region.name:'?:'+region_code
                let district_name = district?district.name:'?:'+district_code
                let constituency_name = constituency?constituency.name:'?:'+constituency_code
                let ward_name = ward?ward.name:'?:'+ward_code
                let centre_name = centre?centre.name:'?:'+centre_code

                //find user
                let user_type = detail?detail.user_type:""
                let user_name = ""
                let user_code = 0
                if (user_type==="observer") {
                  user_code = detail?detail.observer_code:0
                  let observer = this.$store.getters.getObserverByCode(user_code)
                  user_name = observer?observer.first_name+" "+observer_lastname:"?: OB:"+user_code
                }else{
                  user_code = detail?detail.uid:""
                  let user = this.$store.getters.getUserByUid(user_code)
                  user_name = user?user.name:"?: US:"+user_code
                }

                if (detail) {
                  resultsPlus.push({
                    ...it,
                    ...detail,
                    region_name:region_name,
                    district_name:district_name,
                    constituency_name:constituency_name,
                    ward_name:ward_name,
                    centre_name:centre_name,

                    user_name:user_name,
                    user_code:user_code,
                    created_by:user_name
                  })
                }
              }); 
             return resultsPlus 
            },
            CALCULATE_CANDIDATES_RESULTS(results,resultsType,percentage){
              if(results===null){
                results = this.results(resultsType) 
              }
              let candidates = this.candidates 
              let number = 0
              
              let candidatesPlus = []
              let TOTAL_VOTES = 0
              if (!results) {return null}
              if (!candidates) {return []}

              //add candidate_code
              candidates.forEach(cand => {
                let candidate_code = cand.code
                let party_code = cand.party_code

                //find party
                let party = this.$store.getters.getPartyByCode(party_code)
                let party_name = party?party.name:"?:"+party_code
                let party_short_name = party?party.party_short_name:"?:"+party_code
                let party_color = party?party.color_code:""

                //calculate
                let totalVotes = 0
                number = number + 1
                results.forEach(rs => {
                  if (rs.candidate_code === candidate_code) {
                    totalVotes = totalVotes +(rs.votes*1)
                  }
                }); 
                //combine
                TOTAL_VOTES = TOTAL_VOTES+totalVotes
                candidatesPlus.push({
                  ...cand,
                  votes:totalVotes,
                  no:number,
                  candidate_name:this.TEXT_UP11(cand.name),
                  candidate_code:cand.code,
                  candidate_gender:this.TEXT_UP11(cand.gender),
                  party_name:this.TEXT_UP11(party_name),
                  party_short_name:this.TEXT_UP(party_short_name),
                  party_color:party_color
                })
              });

              //calculate percentage
              if (percentage) {
                candidatesPlus.forEach(element => {
                  let votes = element.votes
                  let p = votes/TOTAL_VOTES*100
                  element.votes = p?p:0

                });
              }

              return candidatesPlus
            },
            CALCULATE_CANDIDATES_RESULTS_BY_LOCATION(results,resultsType,location,code){
              if(results===null){
                results = this.results(resultsType) 
              }
              let candidates = this.candidates 
              let number = 0
              
              let candidatesPlus = []
              let TOTAL_VOTES = 0
              if (!results) {return null}
              if (!candidates) {return []}

              //add candidate_code
              candidates.forEach(cand => {
                let candidate_code = cand.code
                let party_code = cand.party_code

                //find party
                let party = this.$store.getters.getPartyByCode(party_code)
                let party_name = party?party.name:"?:"+party_code
                let party_short_name = party?party.party_short_name:"?:"+party_code
                let party_color = party?party.color_code:""

                //calculate
                let totalVotes = 0
                number = number + 1 
                results.forEach(rs => {
                  //
                  let location_code = null
                  if (this.TEXT_UP(location)===this.TEXT_UP("districts")) {
                    location_code = rs.district_code
                  } else if (this.TEXT_UP(location)===this.TEXT_UP("constituencies")) {
                    location_code = rs.constituency_code
                  } else {
                    location_code = rs.region_code
                  }

                  //check location
                  if (location_code*1 === code*1) {
                    if (rs.candidate_code === candidate_code) {
                      totalVotes = totalVotes +(rs.votes*1)
                    } 
                  } 
                }); 
                
                //combine
                TOTAL_VOTES = TOTAL_VOTES+totalVotes
                candidatesPlus.push({
                  ...cand,
                  votes:totalVotes,
                  no:number,
                  candidate_name:this.TEXT_UP11(cand.name),
                  candidate_code:cand.code,
                  candidate_gender:this.TEXT_UP11(cand.gender),
                  party_name:this.TEXT_UP11(party_name),
                  party_short_name:this.TEXT_UP(party_short_name),
                  party_color:party_color
                })
              });

              //calculate percentage
              if (candidatesPlus) {
                candidatesPlus.forEach(element => {
                  let votes = element.votes
                  let p = votes/TOTAL_VOTES*100
                  element.votes_percent = p?p:0

                });
              }

              return candidatesPlus
            },
            CALCULATE_REGIONS_RESULTS(resultsType){
              let results = this.CALCULATE_PLUS(resultsType)
              let regions = this.regions
              let regionsPlus = []
              let number = 0
              if (!results) {return null}
              if (!regions) {return null}

              //add candidate_code
              regions.forEach(res => {
                let region_code = res.code
                let totalVotes = 0
                number = number + 1
                //
                results.forEach(rs => {
                  if (rs.region_code === region_code) {
                    totalVotes = totalVotes +(rs.votes*1)
                  }
                });

                //
                regionsPlus.push({
                  ...res,
                  votes:totalVotes,
                  region_name:res.name,
                  no:number
                })
              }); 
              return regionsPlus
            },
            CALCULATE_DISTRICTS_RESULTS(resultsType){
              let results = this.CALCULATE_PLUS(resultsType)
              let districts = this.districts
              let districtsPlus = []
              let number = 0
              if (!results) {return null}
              if (!districts) {return null}

              //add candidate_code
              districts.forEach(dis => {
                let district_code = dis.code
                let region_code = dis.region_code
                
                //find region
                let region = this.$store.getters.getRegionByCode(region_code)
                let region_name = region?region.name:""

                //calculate
                let totalVotes = 0
                number = number +1
                results.forEach(rs => {
                  if (rs.district_code === district_code) {
                    totalVotes = totalVotes +(rs.votes*1)
                  }
                });

                //combine
                districtsPlus.push({
                  ...dis,
                  votes:totalVotes,
                  no:number,
                  district_name:dis.name,
                  region_name:region_name
                })
              });

              return districtsPlus
            },
            CALCULATE_DISTRICTS_CANDIDATE_RESULTS(results,candidate_code,resultsType){
              if(results === null){
                let results = this.CALCULATE_PLUS(resultsType) 
              } 
              let districts = this.districts
              let districtsPlus = []
              let number = 0
              let TOTAL_VOTES = 0
              if (!results) {return null}
              if (!districts) {return null}
              if (!candidate_code) {return null}

              //add  
              districts.forEach(dis => {
                let district_code = dis.code
                let region_code = dis.region_code
                
                //find region
                let region = this.$store.getters.getRegionByCode(region_code)
                let region_name = region?region.name:""

                //calculate
                let totalVotes = 0
                number = number +1
                results.forEach(rs => {
                  if (rs.candidate_code === candidate_code) {
                    if (rs.district_code === district_code) {
                      totalVotes = totalVotes +(rs.votes*1)
                    }  
                  }
                });

                TOTAL_VOTES = TOTAL_VOTES +totalVotes
                //combine
                districtsPlus.push({
                  ...dis,
                  votes:totalVotes,
                  no:number,
                  district_name:dis.name,
                  region_name:region_name
                })
              });

              //calculate percentage
              let pl_districts = []
              districtsPlus.forEach(element => {
                let votes = element.votes
                let percentage = votes/TOTAL_VOTES*100
                pl_districts.push({
                  ...element,
                  votes_percent:percentage
                })
              });


              return pl_districts
            },
            CALCULATE_RESULTS_INDICATOR(type){
              let results_district = this.CALCULATE_PLUS("district")
              let results_constituency = this.CALCULATE_PLUS("constituency")
              let results_ward = this.CALCULATE_PLUS("ward")
              let results_centre = this.CALCULATE_PLUS("centre")

              let regions = this.regions
              let districts = this.districts
              let constituencies = this.constituencies
              let wards = this.wards
              let centres = this.centres 
              

              //totals
              let total_districts = districts?districts.length:0 
              let total_constituencies = constituencies?constituencies.length:0 
              let total_wards = wards?wards.length:0 
              let total_centres = centres?centres.length:0 

              let totalResultsDistricts = 0
              let totalResultsConstituencies = 0
              let totalResultsWards = 0
              let totalResultsCentre = 0

              //calculate districs
              if (results_district) {
                let districtsCodes = []
                results_district.forEach(element => {
                  let code = element.district_code?((element.district_code)*1):0
                  let index = districtsCodes.indexOf(code)
                  if (index===-1) {
                    districtsCodes.push(code)
                    totalResultsDistricts = totalResultsDistricts+1
                  }

                });
              }

              //calculate constituencies
              if (results_constituency) {
                let constituenciesCodes = []
                results_constituency.forEach(element => {
                  let code = element.constituency_code?((element.constituency_code)*1):0
                  let index = constituenciesCodes.indexOf(code)
                  if (index===-1) {
                    constituenciesCodes.push(code)
                    totalResultsConstituencies = totalResultsConstituencies+1
                  }

                });
              }

              //calculate wards
              if (results_ward) {
                let wardsCodes = []
                results_ward.forEach(element => {
                  let code = element.ward_code
                  let index = wardsCodes.indexOf(code)
                  if (index===-1) {
                    wardsCodes.push(code)
                    totalResultsWards = totalResultsWards+1
                  }

                });
              }

              //calculate centres
              if (results_centre) {
                let centreCodes = []
                results_centre.forEach(element => {
                  let code = element.centre_code
                  let index = centreCodes.indexOf(code)
                  if (index===-1) {
                    centreCodes.push(code)
                    totalResultsCentre = totalResultsCentre+1
                  }

                });
              }
               
              //calculate percentages
              let p_districts = (totalResultsDistricts*100)/total_districts
              let p_constituencies = (totalResultsConstituencies*100)/total_constituencies
              let p_wards = totalResultsWards*100/total_wards
              let p_centres = totalResultsCentre*100/total_centres

              
             return [
                    {name:"Districts",value:p_districts,color:"b2"},
                    {name:"Constituencies",value:p_constituencies,color:"accent"},
                    {name:"Wards",value:p_wards,color:"b2"},
                    {name:"Centres",value:p_centres,color:"accent"}
                ]
            },
            CALCULATE_QUESTION_RESPONSE(responses){

              
              if (!responses) {
                responses = this.questionResponses 
              } 
              let responsesPlus = []
              if (this.nul(responses)) {return null}  
              console.log(this.nul(responses));  

              //ADD DETAILS
              let NUMBER = 0
              responses.forEach(it => {
                let checklist_code = it.question_code
                NUMBER = NUMBER+1

                //find checklist
                let checklist = this.$store.getters.getQuestionChecklistByCode(checklist_code)
                let question_tag = checklist?checklist.question_tag:""
                let question_tag_value = checklist?checklist.question_tag_value:""
                let question_number = checklist?checklist.question_number:""
                let question_body = checklist?checklist.question_body:""
                let question_predefined_answer = checklist?checklist.question_predefined_answer:""
                //
                let question_stage_code = checklist?checklist.question_stage_code:null
                let question_timeline_code = checklist?checklist.question_timeline_code:null
                let question_category_code = checklist?checklist.question_category_code:null
                let question_type_code = checklist?checklist.question_type_code:null

                let observer_code = it.observer_code
                let centre_code = it.centre_code
                let ward_code = it.ward_code
                let constituency_code = it.constituency_code
                let district_code = it.district_code
                let region_code = it.region_code

                //find Stage
                let question_stage = this.$store.getters.getQuestionStageByCode(question_stage_code)
                let question_stage_name = question_stage?question_stage.name:"?:"+question_stage_code  
                //find timeline
                let question_timeline = this.$store.getters.getQuestionTimelineByCode(question_timeline_code)
                let question_timeline_name = question_timeline?question_timeline.name:"?:"+question_timeline_code  
                //find category
                let question_category = this.$store.getters.getQuestionCategoryByCode(question_category_code)
                let question_category_name = question_category?question_category.name:"?:"+question_category_code  
                //find type
                let question_type = this.$store.getters.getQuestionTypeByCode(question_type_code)
                let question_type_name = question_type?question_type.name:"?:"+question_type_code 

                //find observer
                let observer = this.$store.getters.getObserverByCode(observer_code)
                let observer_name = observer?observer.first_name+" "+observer.last_name:"?:"+observer_code 
                let observer_email = observer?observer.email:"?:"+observer_code 
                let observer_phone_number = observer?observer.phone_number:"?:"+observer_code 

                //find centre
                let centre = this.$store.getters.getCentreByCode(centre_code)
                let centre_name = centre?centre.name:"?:"+centre_code 
                //find ward
                let ward = this.$store.getters.getWardByCode(ward_code)
                let ward_name = ward?ward.name:"?:"+ward_code 
                //find constituency
                let constituency = this.$store.getters.getConstituencyByCode(constituency_code)
                let constituency_name = constituency?constituency.name:"?:"+constituency_code 
                //find district
                let district = this.$store.getters.getCentreByCode(district_code)
                let district_name = district?district.name:"?:"+district_code 
                //find region
                let region = this.$store.getters.getCentreByCode(region_code)
                let region_name = region?region.name:"?:"+region_code 

                
                //split question answer
                let question_answer_explanation = ""
                let question_answer = it.question_answer
                let index = null
                if (question_answer) {
                   index = question_answer.indexOf("#") 
                }else{
                  console.log(it); 
                }
                
                 
                if (index!==-1) {
                  if (question_answer) {
                    let aValues = question_answer.split("#")
                    question_answer = aValues[0]
                    question_answer_explanation=aValues[1] 
                    
                  } 
                }  
                
                //
                let answer =""
                let explanation = question_answer_explanation
                if (question_answer) {
                  let value = question_answer.split(question_number)
                  answer = value[1]  
                } 
              
                //join
                responsesPlus.push({
                  ...it,
                  no:NUMBER,
                  answer:answer,
                  explanation:explanation,
                  question_answer:question_answer,
                  question_answer_explanation:question_answer_explanation,
                  question_predefined_answer:question_predefined_answer,
                  question_flagged:it.flagged?"Yes":"No",
                  created_at:this.convertDate(it.created_at),
                  question_tag:question_tag,
                  question_tag_value:question_tag_value,
                  question_number:question_number,
                  question_code :checklist.code,
                  question_body :question_body,

                  question_stage_code:question_stage_code,
                  question_stage_name:question_stage_name,

                  question_timeline_code:question_timeline_code,
                  question_timeline_name:question_timeline_name,

                  question_category_code:question_category_code,
                  question_category_name:question_category_name,

                  question_type_code:question_type_code,
                  question_type_name:question_type_name, 

                  user_name:observer_name,
                  user_email:observer_email,
                  user_phone_number:observer_phone_number,
                  centre_name:centre_name,
                  ward_name:ward_name,
                  constituency_name:constituency_name,
                  district_name:district_name,
                  region_name:region_name
                }) 
              }); 
             return responsesPlus 
            },
            CALCULATE_QUESTION_RESPONSE1(responses){

              
              if (!responses) {
                responses = this.questionResponses 
              } 
              let responsesPlus = []
              if (!responses) {return null}  

              //ADD DETAILS
              let NUMBER = 0
              responses.forEach(it => {
                let checklist_code = it.question_code
                NUMBER = NUMBER+1

                //find checklist
                let checklist = this.$store.getters.getQuestionChecklistByCode(checklist_code)
                let question_tag = checklist?checklist.question_tag:""
                let question_tag_value = checklist?checklist.question_tag_value:""
                let question_number = checklist?checklist.question_number:""
                let question_body = checklist?checklist.question_body:""
                let question_predefined_answer = checklist?checklist.question_predefined_answer:""
                //
                let question_stage_code = checklist?checklist.question_stage_code:null
                let question_timeline_code = checklist?checklist.question_timeline_code:null
                let question_category_code = checklist?checklist.question_category_code:null
                let question_type_code = checklist?checklist.question_type_code:null

                let observer_code = it.observer_code
                let centre_code = it.centre_code
                let ward_code = it.ward_code
                let constituency_code = it.constituency_code
                let district_code = it.district_code
                let region_code = it.region_code

                //find Stage
                let question_stage = this.$store.getters.getQuestionStageByCode(question_stage_code)
                let question_stage_name = question_stage?question_stage.name:"?:"+question_stage_code  
                //find timeline
                let question_timeline = this.$store.getters.getQuestionTimelineByCode(question_timeline_code)
                let question_timeline_name = question_timeline?question_timeline.name:"?:"+question_timeline_code  
                //find category
                let question_category = this.$store.getters.getQuestionCategoryByCode(question_category_code)
                let question_category_name = question_category?question_category.name:"?:"+question_category_code  
                //find type
                let question_type = this.$store.getters.getQuestionTypeByCode(question_type_code)
                let question_type_name = question_type?question_type.name:"?:"+question_type_code 

                // //find observer
                // let observer = this.$store.getters.getObserverByCode(observer_code)
                // let observer_name = observer?observer.first_name+" "+observer.last_name:"?:"+observer_code 
                // let observer_email = observer?observer.email:"?:"+observer_code 
                // let observer_phone_number = observer?observer.phone_number:"?:"+observer_code 

                // //find centre
                // let centre = this.$store.getters.getCentreByCode(centre_code)
                // let centre_name = centre?centre.name:"?:"+centre_code 
                // //find ward
                // let ward = this.$store.getters.getWardByCode(ward_code)
                // let ward_name = ward?ward.name:"?:"+ward_code 
                // //find constituency
                // let constituency = this.$store.getters.getConstituencyByCode(constituency_code)
                // let constituency_name = constituency?constituency.name:"?:"+constituency_code 
                // //find district
                // let district = this.$store.getters.getCentreByCode(district_code)
                // let district_name = district?district.name:"?:"+district_code 
                // //find region
                // let region = this.$store.getters.getCentreByCode(region_code)
                // let region_name = region?region.name:"?:"+region_code 

                
                //split question answer
                let question_answer_explanation = ""
                let question_answer = it.question_answer
                let index = null
                if (question_answer) {
                   index = question_answer.indexOf("#") 
                }else{
                  console.log(it); 
                }
                
                 
                if (index!==-1) {
                  if (question_answer) {
                    let aValues = question_answer.split("#")
                    question_answer = aValues[0]
                    question_answer_explanation=aValues[1] 
                    
                  } 
                }  
                
                //
                let answer =""
                let explanation = question_answer_explanation
                if (question_answer) {
                  let value = question_answer.split(question_number)
                  answer = value[1]  
                } 
              
                //join
                responsesPlus.push({
                  ...it,
                  no:NUMBER,
                  answer:answer,
                  explanation:explanation,
                  question_answer:question_answer,
                  question_answer_explanation:question_answer_explanation,
                  question_predefined_answer:question_predefined_answer,
                  question_flagged:it.flagged?"Yes":"No",
                  created_at:this.convertDate(it.created_at),
                  question_tag:question_tag,
                  question_tag_value:question_tag_value,
                  question_number:question_number,
                  question_code :checklist?checklist.code:this.nul,
                  question_body :question_body,

                  question_stage_code:question_stage_code,
                  question_stage_name:question_stage_name,

                  question_timeline_code:question_timeline_code,
                  question_timeline_name:question_timeline_name,

                  question_category_code:question_category_code,
                  question_category_name:question_category_name,

                  question_type_code:question_type_code,
                  question_type_name:question_type_name, 

                  // user_name:observer_name,
                  // user_email:observer_email,
                  // user_phone_number:observer_phone_number,
                  // centre_name:centre_name,
                  // ward_name:ward_name,
                  // constituency_name:constituency_name,
                  // district_name:district_name,
                  // region_name:region_name
                }) 
              }); 
             return responsesPlus 
            },
            CALCULATE_LOCATION_CANDIDATE_RESULTS(results,location="Regions"){
              if(!results){return null}
              let regions = this.regions
              let districs = this.districts
              let candidates = this.candidates

              //REGIONS
              if (this.TEXT_UP(location)===this.TEXT_UP('Regions')) {
                let REGIONS = []
                regions.forEach(reg => {
                  let CANDIDATES = [] 
                  let TOTAL = 0
                  candidates.forEach(cand => {
                    let VOTES = 0
                    let party = null
                    results.forEach(res => {
                      if (res.region_code===reg.code) {
                        if (res.candidate_code===cand.code) {
                          VOTES = VOTES+res.votes
                          if (!party) {
                            party = res.party
                          }
                        }
                      }
                    });
                    TOTAL = TOTAL+VOTES
                    CANDIDATES.push({
                      ...cand,
                      votes:VOTES,
                      party:party
                    })
                  });
                  //CALCULATE PERCENT
                  CANDIDATES.forEach(cand => {
                    cand.percent_votes = cand.votes*100/TOTAL
                  });
                  REGIONS.push({
                    ...reg,
                    votes:TOTAL,
                    candidates: CANDIDATES
                  })
                });
                return REGIONS
              }else if (this.TEXT_UP(location)===this.TEXT_UP('Districts')) {
                let DISTRICTS = []
                districs.forEach(reg => {
                  let CANDIDATES = [] 
                  let TOTAL = 0
                  candidates.forEach(cand => {
                    let VOTES = 0
                    let party = null
                    results.forEach(res => {
                      if (res.district_code===reg.code) {
                        if (res.candidate_code===cand.code) {
                          VOTES = VOTES+res.votes
                          if (!party) {
                            party = res.party
                          }
                        }
                      }
                    });
                    TOTAL = TOTAL+VOTES
                    CANDIDATES.push({
                      ...cand,
                      votes:VOTES,
                      party:party
                    })
                  });
                  //CALCULATE PERCENT
                  CANDIDATES.forEach(cand => {
                    cand.percent_votes = cand.votes*100/TOTAL
                  });
                  DISTRICTS.push({
                    ...reg,
                    votes:TOTAL,
                    candidates: CANDIDATES
                  })
                });
                return DISTRICTS
              }else{ return null}
            },

            //--------------------[GEO]------------------
            CALCULATE_GEO(feature,id,color="#006180",opacity=0.9,shortText=false,numberOftext=2,textSize=15){ 
              if(!feature){return null}
              if(!id){return null}

              //---[layer 1]
              let layer = {
                'id': id,
                'type': 'fill',
                'source': id,
                'layout': {},
                'paint': {
                  'fill-color': color,
                  'fill-opacity': opacity
                }
              }

              //---[layer 1]
              let id2="MHUB"+id
              let text = id
              if(shortText){
                text = id.slice(0,numberOftext)
              }
              let layer2 = {
                  'id': id2,
                  'type': "symbol",
                  'source': id2,
                  'layout': {
                      "text-field": text, 
                      "text-size": textSize,
                      'symbol-placement': "point"
                  },
                  'paint': {
                      "text-color": "#000",
                      "text-halo-color": "#fff",
                      "text-halo-width": 1.9,
                      "text-halo-blur": 0.1,
                  }
              }

              let source = {
                'type': 'geojson',
                'data':{
                    "features":[ feature ],
                    "type": "FeatureCollection"
                    }, 
              } 
              return {
                id:id,
                id2:id2,
                color:color,
                opacity:opacity,
                layer:layer,
                layer2:layer2,
                source:source
              } 
            },
            CALCULATE_GEOs(feature,id,color="#006180",opacity=0.8){
              if(!feature){return null}
              if(!id){return null}
              let layer = {
                'id': id,
                'type': 'fill',
                'source': id,
                'layout': {},
                'paint': {
                  'fill-color': color,
                  'fill-opacity': opacity
                }
              }

              let source = {
                'type': 'geojson',
                'data':{
                    "features":[ feature ],
                    "type": "FeatureCollection"
                    }, 
              } 
              return {
                id:id,
                color:color,
                opacity:opacity,
                layer:layer,
                source:source
              } 
            },



            //---------------------[ACCESS AND PERMISSION]------------

            permission_delete_user(ud,user){ 
              if (!ud) {
                this.not.notDialog(true,true,"PERMISSION DENIED","You are not allowed to perform this action. Please, contact administrator for more inf.","OK")
                return false
              }
              if (user.email==="admin@tidziwe.com") {
                  this.not.notDialog(true,true,"PERMISSION DENIED","You are not allowed to this account.","OK")
                  return false
              }else if (ud.role!=="administrator") {
                  this.not.notDialog(true,true,"PERMISSION DENIED","You are not allowed to perform this action. Please, contact administrator for more inf.","OK")
                  return false
              } else if (ud.role==="administrator") {
                return true
              }  
              return false
            },
            permission_delete_observer(user){
              if (user.role!=="administrator") {
                  this.not.notDialog(true,true,"PERMISSION DENIED","You are not allowed to perform this action. Please, contact administrator for more inf.","OK")
                  return false
              } else if (user.role==="administrator") {
                return true
              }  
              return false
            },

            ACCESS_READ(p_name){
              return true
              let us = this.us
              let ud = this.JOINED_ud
              if (!us) { 
                return false
              }else if (!ud) { 
                return false
              }

              let permissions = ud.permissions
              let access = true
              if (!permissions) { 
                return false
              }else{
                access = this.ACCESS_PERMISSION(permissions.read,p_name)
                if (!access) { 
                  return false
                }
                return true
              }
            },
            ACCESS_WRITE(p_name){
              return true
              let us = this.us
              let ud = this.JOINED_ud
              if (!us) { 
                return false
              }else if (!ud) { 
                return false
              }

              let permissions = ud.permissions
              let access = true
              if (!permissions) { 
                return false
              }else{
                access = this.ACCESS_PERMISSION(permissions.write,p_name)
                if (!access) { 
                  return false
                }
                return true
              }
            },
            ACCESS_EDIT(p_name){
              return true
              let us = this.us
              let ud = this.JOINED_ud
              if (!us) { 
                return false
              }else if (!ud) { 
                return false
              }

              let permissions = ud.permissions
              let access = true
              if (!permissions) { 
                return false
              }else{
                access = this.ACCESS_PERMISSION(permissions.edit,p_name)
                if (!access) { 
                  return false
                }
                return true
              }
            },
            ACCESS_DELETE(p_name){
              return true
              let us = this.us
              let ud = this.JOINED_ud
              if (!us) { 
                return false
              }else if (!ud) { 
                return false
              }

              let permissions = ud.permissions
              let access = true
              if (!permissions) { 
                return false
              }else{
                access = this.ACCESS_PERMISSION(permissions.delete,p_name)
                if (!access) { 
                  return false
                }
                return true
              }
            },
           ACCESS_PAGE(page_name, show=true){
              return true
              let us = this.us
              let ud = this.JOINED_ud

              //if admin
              if (us) { 
                let email = us.email
                if (email === "admin@tidziwe.com") {
                  return true
                }
              }
              
              if (!us) {
                this.oneClick=true
                if (show == true) {
                  this.notDialog(true,true,"ACCESS DENIED","You must login to access this page. For more info please contact admin.",'CANCEL',"LOGIN",{
                   code:pageName+"=REDIRECT-LOGIN" 
                  }) 
                }
                return false
              }else if (!ud) {
                // this.oneClick=true
                // this.notDialog(true,true,"ACCESS DENIED","You account has an error. Restart the page. If you continue seeing this error. Please contact admin.",null,"OK",{
                //  code:pageName+"=RESTART-PAGE" 
                // })
                return false
              }

              let permissions = ud.permissions
              let access = true
              if (!permissions) {
                // this.oneClick=true
                // this.notDialog(true,true,"ACCESS DENIED","Sorry, you do not have any permission to the system. For more info please contact admin.",null,"OK",{
                //  code:pageName+"=--" 
                // })
                return false
              }else{
                access = this.ACCESS_PERMISSION(permissions.pages,page_name)
                if (!access) {
                  // this.oneClick=true
                  // this.notDialog(true,true,"ACCESS DENIED","You have no access to this page. For more info please contact admin.",null,"OK",{
                  //   code:pageName+"=--" 
                  // })
                  return false
                }
                return true
              }
            }, 
            ACCESS_PERMISSION(permission,name){
              return true
              if(!permission){return false}
              if(!name){return false}
              let access = false

              permission.forEach(element => {
                let n1 = this.TEXT_UP(element.name ) 
                let n2 = this.TEXT_UP(name)
                if (n1===n2) {
                  access = element.allow?true:false
                } 
              }); 
              return access 
            },

            //-------------------[SELECTOR]--------------------
            selectorNames(array){
              if (!array) {
                return null
              }
              let names =[]
              array.forEach(ar => {
                names.push(ar.code+". "+ar.name)  
              }); 
              return names
            },
            selectorCodeName(array,code){
              if (!array) {
                return null
              }
              if (!code) {
                return null
              }
              let item = array.find(ar => {
                return ar.code == code  
              }); 
              if (!item) {
                return null
              }
              //console.log(array,code,"mmmmmmmmmmmmmmm");
              
              return item.code+". "+item.name
            },
            selectorNamesCode(array,name){
              if (!name) {
                return null
              }
              if (!array) {
                return null
              }
              name = ''+name 
              if (!name.includes(". ")) { 
                return name
              } 
              
              let code = name.split(". ")[0]
              let item = array.find(it=>{
                return it.code == code
              })
              if (!item) {
                //console.log(code);
                
              }
              //console.log(array,name);
              return item?item.code:0
            },
            //--------------------[find]-----------------------
            findCodeName(array,code){
              if (!array) {
                return "..."
              }
              if (!code) {
                return "..."
              }
              let item = array.find(it=>{
                return it.code == code
              })

              if (!item) {
                return "..."
              }

              return item.name
            },
            async USER_MONITOR(time=500){
              try {
                  setTimeout(async() => {
                    try {
                      let us = this.us
                      let ud = this.ud
                      let upTime = this.upTime
                      let loggedTime = this.loggedTime
                      let ps = this.processes
                      let ld = this.loading
                      let res = this.responses
                      let access = this.MBS.actions.GET_ACCESS()  
                      
                      let user_details_data = await DB.getUserDetails()
                      let current_uid = user_details_data.current_uid
                      let action_request_uid = user_details_data.action_request_uid
                      let logged_uid = user_details_data.logged_uid
                      let  user_details = user_details_data.user_details  
                      if (us) {
                        if (action_request_uid) { 
                          //
                        } 
                        if (current_uid) { 
                          this.$store.dispatch('fi_get_user_items',{
                            name:DATA.ITEMS.USER_DETAILS.values,
                            on:true, 
                            cash:true, 
                            get:false
                          }) 
                        } 
                        
                        if (user_details) {
                          this.$store.dispatch('setUserDetails',{
                            ...user_details,
                            action_request_uid:action_request_uid,
                            current_uid:current_uid
                          })
                        } 
                        //IF ADMIN
                        if (us.email === DATA.APP.ADMIN_EMAIL) {
                          // this.$store.dispatch('fi_get_item',{
                          //   name:DATA.ITEMS.ERRORS.values,
                          //   on:true, 
                          //   cash:true, 
                          //   get:true
                          // })   
                          // this.$store.dispatch('fi_get_user_items',{
                          //   name:DATA.ITEMS.VISITERS.values,
                          //   on:true, 
                          //   cash:true, 
                          //   get:true
                          // }) 
                        }  
                      }else{
                        this.$store.dispatch('setUserDetails',null)
                      } 
                    } catch (error) {
                      this.MBS.actions.error({
                          error:error,
                          from:'USER_MONITOR',
                          page:PAGE_NAME, 
                      })
                    }
                  }, time); 
              } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'USER_MONITOR',
                    page:PAGE_NAME, 
                })
              }
            },
             
        },
        watch:{  
          us(us){
            this.INITIATE_DB(us?us.uid:null)
            this.USER_MONITOR(1)
          }
        }   
    }
    
</script>
 
